// components/Header/Header.jsx
import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('.header');
      if (window.scrollY > 100) {
        header.style.background = 'rgba(255, 255, 255, 0.95)';
        header.style.backdropFilter = 'blur(10px)';
      } else {
        header.style.background = 'white';
        header.style.backdropFilter = 'none';
      }

      // Active navigation link highlighting
      const sections = document.querySelectorAll('.section, .home-section');
      let current = '';
      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        if (window.pageYOffset >= (sectionTop - 200)) {
          current = section.getAttribute('id');
        }
      });
      
      if (current) {
        setActiveSection(current);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (sectionId) => {
    const target = document.querySelector(`#${sectionId}`);
    if (target) {
      const headerOffset = 80;
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };

  const handleLogoDoubleClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = function() {
      if (this.files[0]) {
        const logoElement = document.getElementById('company-logo');
        const reader = new FileReader();
        reader.onload = function(e) {
          logoElement.src = e.target.result;
        };
        reader.readAsDataURL(this.files[0]);
      }
    };
    input.click();
  };

  return (
    <header className="header">
      <nav className="nav-container">
        <img 
          src="/img/Logo.png"  // Ruta correcta después de copiar a public/img/
          alt="DB Alambrados Logo" 
          className="logo" 
          id="company-logo"
          onDoubleClick={handleLogoDoubleClick}
          onError={(e) => {
            console.log('Error cargando logo, usando fallback');
            e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjUwIiB2aWV3Qm94PSIwIDAgMjAwIDUwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjUwIiBmaWxsPSIjM0E4MDc5Ii8+Cjx0ZXh0IHg9IjEwMCIgeT0iMzAiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxOCIgZm9udC13ZWlnaHQ9ImJvbGQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5EQiBBTEFNQlJBRE9TPC90ZXh0Pgo8L3N2Zz4K';
          }}
        />
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`} id="nav-menu">
          <li>
            <a 
              href="#home" 
              onClick={(e) => { e.preventDefault(); handleNavClick('home'); }}
              style={{ color: activeSection === 'home' ? '#3A8079' : '#333' }}
            >
              Home
            </a>
          </li>
          <li>
            <a 
              href="#servicios" 
              onClick={(e) => { e.preventDefault(); handleNavClick('servicios'); }}
              style={{ color: activeSection === 'servicios' ? '#3A8079' : '#333' }}
            >
              Servicios
            </a>
          </li>
          <li>
            <a 
              href="#nosotros" 
              onClick={(e) => { e.preventDefault(); handleNavClick('nosotros'); }}
              style={{ color: activeSection === 'nosotros' ? '#3A8079' : '#333' }}
            >
              Nosotros
            </a>
          </li>
          <li>
            <a 
              href="#ubicacion" 
              onClick={(e) => { e.preventDefault(); handleNavClick('ubicacion'); }}
              style={{ color: activeSection === 'ubicacion' ? '#3A8079' : '#333' }}
            >
              Ubicación
            </a>
          </li>
          <li>
            <a 
              href="#contacto" 
              onClick={(e) => { e.preventDefault(); handleNavClick('contacto'); }}
              style={{ color: activeSection === 'contacto' ? '#3A8079' : '#333' }}
            >
              Contacto
            </a>
          </li>
        </ul>
        <div 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`} 
          id="hamburger"
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>
    </header>
  );
};

export default Header;